import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfFont,
  PdfBrush,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutLabelTextGen } from '../layoutLabelText';
import { OptsLabelText } from '../optsLabelText';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import { IItemCount } from '@educraft/base';
import { anagram } from '../../core/variation';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/label';

/**
 * Presmycky (Anagrams) - Scrambled word puzzles
 *
 * Layout: Variable pages, 5 items per page.
 * Each row: image (left), scrambled word (top-right), writing line (bottom-right).
 *
 * Migrated from C# EduFrame.Img10.Generators.Presmycky
 */
export class Presmycky implements ILayoutLabelTextGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabelText): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);
    const itemsPerPage = 5;
    const totalPages = Math.ceil(opts.list.length / itemsPerPage);

    const font = new PdfFont(PdfFont.FONT_NAME, 36);

    for (let pageIdx = 0; pageIdx < totalPages; pageIdx++) {
      const page = pdf.addPage();
      const startItem = pageIdx * itemsPerPage;
      const endItem = Math.min(startItem + itemsPerPage, opts.list.length);

      const { origin, size } = calcOrigin(1, itemsPerPage, 0, PdfSize.A4);

      for (let i = 0; i < itemsPerPage; i++) {
        const itemInd = startItem + i;

        const rect = new PdfRect(origin.x, origin.y + i * size.height, size.width, size.height);
        const imgRect = new PdfRect(
          rect.left + margin,
          rect.top + margin,
          rect.height - 2 * margin,
          rect.height - 2 * margin
        );
        const r1 = new PdfRect(
          imgRect.right + margin,
          imgRect.top,
          rect.right - imgRect.width - 3 * margin,
          imgRect.height / 2
        );
        const r2 = new PdfRect(r1.left, r1.bottom, r1.width, r1.height);

        page.drawRectangle(GUtil.cutPen, null, rect);

        if (itemInd < endItem) {
          const variant = anagram(opts.list[itemInd].text, opts.data.random);
          const f = page.adjustFont(r1.width, [variant], font);

          const p1 = new PdfPoint(r2.left, r2.centerY);
          const p2 = new PdfPoint(r2.right, r2.centerY);
          page.drawLine(GUtil.writePen, p1, p2);

          page.drawLabel(opts.list[itemInd].label, { rect: imgRect });
          page.drawString(variant, f, PdfBrush.Black, null, r1, ETextAlign.Center);
        }
      }
    }
  }
}
